import "vanilla-cookieconsent/dist/cookieconsent.css";
import * as CookieConsent from "vanilla-cookieconsent";

export function initCookieConsent() {
    CookieConsent.run({
        guiOptions: {
            consentModal: {
                layout: "box",
                position: "bottom right",
                equalWeightButtons: true,
                flipButtons: false
            },
            preferencesModal: {
                layout: "box",
                position: "right",
                equalWeightButtons: true,
                flipButtons: false
            }
        },
        categories: {
            necessary: {
                readOnly: true
            },
            analytics: {}
        },
        language: {
            default: "pt",
            autoDetect: "browser",
            translations: {
                pt: {
                    consentModal: {
                        description: "Este site utiliza cookies para aprimorar sua navegação e aperfeiçoar nossa comunicação com você. Ao continuar navegando, você está ciente e de acordo com o armazenamento desses dados.",
                        acceptAllBtn: "Aceitar todos",
                        acceptNecessaryBtn: "Rejeitar todos",
                        showPreferencesBtn: "Gerenciar preferencias",
                    },
                    preferencesModal: {
                        title: "Definição de cookies",
                        acceptAllBtn: "Aceitar todos",
                        acceptNecessaryBtn: "Rejeitar todos",
                        savePreferencesBtn: "Salvar preferencias",
                        closeIconLabel: "Fechar alerta",
                        serviceCounterLabel: "Serviços",
                        sections: [
                            {
                                description: "Quando visita um website, este pode armazenar ou recolher informações no seu navegador, principalmente na forma de cookies. Essas informações podem ser sobre você, suas preferências ou sobre seu dispositivo, e são utilizadas principalmente para o website funcionar conforme esperado.</br> O site dispõe de alguns cookies estritamente necessários. Esses cookies não armazenam informação pessoal identificável. Eles são necessários para que o website funcione e não podem ser desligados nos nossos sistemas."
                            },
                            {
                                title: "Cookies necessários <span class=\"pm__badge\">Sempre ativado</span>",
                                description: "Cookies estritamente necessários para o bom funcionamento do ambiente, permitindo a navegação no site e a utilização de seus recursos.",
                                linkedCategory: "necessary"
                            },
                            {
                                title: "Cookies analíticos",
                                description: "Cookies analíticos são usados para entender como os visitantes interagem com o site. Esses cookies ajudam a fornecer informações sobre métricas como número de visitantes, taxa de rejeição, fonte de tráfego etc.",
                                linkedCategory: "analytics"
                            },
                        ]
                    }
                }
            }
        },
        cookie: {
            sameSite: "Lax",
            secure: window.location.protocol === "https:",
            domain: window.location.hostname
        }
    });
}